import React, { useContext, useEffect, useState } from "react";
import styles from "./Review.module.scss";
import { Context } from "../Store";
import { isMobile } from "react-device-detect";
import { trackEvent } from "../utils/helpers";

const Review = () => {
  const [state] = useContext(Context);
  const [hoveredStars, setHoveredStars] = useState(0);

  const googleReviewUrl = state.googleurl;
  const otherReviewUrl = state.feedbackurl;
  const isUkOrUsStory = state.country === "uk" || state.country === "us";

  const hasReviewUrl = isUkOrUsStory ? !!googleReviewUrl : !!otherReviewUrl;

  useEffect(() => {
    if (hasReviewUrl) {
      trackEvent("ab_test_reviews", "Variant Seen", "circles");
    }
  }, [hasReviewUrl]);

  if (!hasReviewUrl) {
    return null;
  }

  const handleStarClick = (starIndex) => {
    trackEvent("Google Review", "Circle Clicked", `${starIndex} circle`);
    // if (!googleReviewUrl) return;
    if (isUkOrUsStory && googleReviewUrl) {
      window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
    } else if (otherReviewUrl) {
      window.open(otherReviewUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <div className={styles.reviewContainer}>
        <div
          className={styles.stripeBg}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/img/${isMobile ? "stripeBgMob" : "stripeBg"}.png)`,
          }}
        />
        <div className={styles.rateGoogle}>
          <div className={styles.dartContainer}>
            <img src="./img/dartHorizontal.svg" alt="Dart" />
          </div>
          <h4>How do you like us?</h4>
          <p>
            {isUkOrUsStory ? "Rate us below and drop a Google review" : "Rate us below and drop a review"}
          </p>
          <div className={styles.stars} onMouseLeave={() => setHoveredStars(0)}>
            {[...Array(5)].map((_, index) => (
              <button
                key={index}
                type="button"
                className={`${styles.starButton} ${hoveredStars >= index + 1 ? styles.starActive : ""}`}
                onMouseEnter={() => setHoveredStars(index + 1)}
                onClick={() => handleStarClick(index + 1)}
                aria-label={`Rate ${index + 1} stars`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  aria-hidden="true"
                  className={styles.dartboardSvg}
                >
                  <circle className={styles.dartboardC1} cx="21" cy="21" r="21" fill="#D8B464" />
                  <circle className={styles.dartboardC2} cx="20.5" cy="20.5" r="14.5" fill="#F6EDDB" />
                  <circle className={styles.dartboardC3} cx="20.5" cy="20.5" r="8.5" fill="#E9D1A8" />
                  <circle className={styles.dartboardC4} cx="20.5" cy="20.5" r="4.5" fill="#D8B464" />
                </svg>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
